module.exports = __webpack_public_path__ + "static/media/id-dark-blue.6abbbd43.png";